/** Returns back the given filename if it ends in .dcm or .dcm.gz (case insensitive), or
 * otherwise returns the given filename back with a .dcm file extension.
 */
export const ensureFilenameHasDcmExtension = (filename: string): string => {
    const filenameLowercase = filename.toLocaleLowerCase();
    return filenameLowercase.endsWith('.dcm') || filenameLowercase.endsWith('.dcm.gz') ? filename : `${filename}.dcm`;
}
